export const elColor: Record<string, string> = {
  wood: "text-green-600",
  木: "text-green-600",

  fire: "text-red-600",
  火: "text-red-600",

  earth: "text-yellow-600",
  土: "text-yellow-600",

  metal: "text-blue-600",
  金: "text-blue-600",

  water: "text-cyan-600",
  水: "text-cyan-600",
};
